import React from 'react'
import { createEvent, EventAttributes } from 'ics'
import { useTranslation } from 'react-i18next'
import { useDownloadFromBlob } from 'utils/useDownloadFromBlob'

type EventAttributesModified = { busyStatus: string } & EventAttributes

const useCreateProposalDueDateIcs = () => {
  const { t } = useTranslation()
  const downloadFromBlob = useDownloadFromBlob()

  const createProposalDueDateIcs = React.useCallback(
    (proposalDueDateDisplayDate: string, title: string, description: string, proposalDueDateDisplayTime: string) => {
      const [year, month, date] = proposalDueDateDisplayDate.split('-').map(Number)
      const [hours, minutes] = proposalDueDateDisplayTime ? proposalDueDateDisplayTime.split(':').map(Number) : [23, 59]

      const icsEvent: EventAttributesModified = {
        start: [year, month, date, 0, 0],
        end: [year, month, date, hours, minutes],
        title: title,
        description: description,
        status: 'CONFIRMED',
        busyStatus: 'FREE'
      }

      createEvent(icsEvent, (error, value) => {
        if (error) {
          console.log({ error })
          return
        }

        downloadFromBlob(value, t('request-for-proposal-reminder'), { type: 'text/calendar' })
      })
    },
    [downloadFromBlob, t]
  )

  return {
    createProposalDueDateIcs: createProposalDueDateIcs
  }
}

export default useCreateProposalDueDateIcs
